__turbopack_context__.v({
  "frame": "UKj7qa_frame",
  "graphic": "UKj7qa_graphic",
  "letter": "UKj7qa_letter",
  "mark": "UKj7qa_mark",
  "root": "UKj7qa_root",
  "sizer": "UKj7qa_sizer",
});
